/**
 * Learning Hub — Index des 9 parcours d'apprentissage.
 * Seuls les 3 premiers ont du contenu (LOT 42). Les 6 suivants seront ajoutés au LOT 43.
 */

export interface LessonSection {
  type: 'concept' | 'why' | 'methodology' | 'in-product' | 'further';
  title: string;
  content: string;
}

export interface Lesson {
  slug: string;
  title: string;
  duration: string;
  glossaryTerms: string[];
  sections: LessonSection[];
  linkedModule?: {
    label: string;
    path: string;
    icon: string;
  };
}

export interface Course {
  slug: string;
  title: string;
  subtitle: string;
  icon: string;
  lessonCount: number;
  available: boolean;
}

export const COURSES: Course[] = [
  {
    slug: 'growth-101',
    title: 'Growth Marketing 101',
    subtitle: 'Les fondamentaux du growth marketing',
    icon: 'TrendingUp',
    lessonCount: 6,
    available: true,
  },
  {
    slug: 'content-marketing',
    title: 'Content Marketing',
    subtitle: 'Creer et distribuer du contenu efficace',
    icon: 'PenTool',
    lessonCount: 7,
    available: true,
  },
  {
    slug: 'seo-referencement',
    title: 'SEO & Referencement',
    subtitle: 'Optimiser sa visibilite dans les moteurs de recherche',
    icon: 'Search',
    lessonCount: 6,
    available: true,
  },
  {
    slug: 'sales-intelligence',
    title: 'Sales Intelligence',
    subtitle: 'Comprendre et convertir vos prospects',
    icon: 'Target',
    lessonCount: 6,
    available: true,
  },
  {
    slug: 'marketing-automation',
    title: 'Marketing & Campagnes',
    subtitle: 'Automatiser et piloter vos campagnes',
    icon: 'Zap',
    lessonCount: 5,
    available: true,
  },
  {
    slug: 'referral-virality',
    title: 'Referral & Viralite',
    subtitle: 'Le pouvoir du bouche-a-oreille et du parrainage',
    icon: 'UsersRound',
    lessonCount: 5,
    available: true,
  },
  {
    slug: 'customer-success',
    title: 'Customer Success',
    subtitle: 'Fideliser et satisfaire vos clients',
    icon: 'Heart',
    lessonCount: 6,
    available: true,
  },
  {
    slug: 'data-analytics',
    title: 'Data & Analytics',
    subtitle: 'Prendre des decisions basees sur les donnees',
    icon: 'BarChart3',
    lessonCount: 6,
    available: true,
  },
  {
    slug: 'roadmap-planning',
    title: 'Roadmap & Planification',
    subtitle: 'Planifier et suivre vos strategies',
    icon: 'Map',
    lessonCount: 5,
    available: true,
  },
  {
    slug: 'stripe-billing-v2',
    title: 'Stripe Billing V2',
    subtitle: 'Maitriser la facturation, les plans et les devises',
    icon: 'CreditCard',
    lessonCount: 5,
    available: true,
  },
  {
    slug: 'ai-router-config',
    title: 'AI Router',
    subtitle: 'Configurer et monitorer le routage multi-provider IA',
    icon: 'Zap',
    lessonCount: 4,
    available: true,
  },
  {
    slug: 'plan-gates-management',
    title: 'Plan Gates',
    subtitle: 'Gerer les feature gates et quotas par plan',
    icon: 'Settings',
    lessonCount: 4,
    available: true,
  },
];

/**
 * Map slug -> imported lessons (lazy loaded at call site).
 */
export function getCourseBySlug(slug: string): Course | undefined {
  return COURSES.find((c) => c.slug === slug);
}
